module.exports = __webpack_public_path__ + "static/media/pega_correta3.1ddf54fb.jpg";